import { useQuery } from '@tanstack/react-query';
import { systemMetricsApi } from '../api';

export const useSystemMetrics = () => {
  return useQuery({
    queryKey: ['system-metrics'],
    queryFn: () => systemMetricsApi.getMetrics(),
  });
};
